"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var PropTypes = __importStar(require("prop-types"));
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("../Themes/styled-components"));
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  align-self: flex-end;\n  justify-content: center;\n"], ["\n  display: flex;\n  width: 100%;\n  align-self: flex-end;\n  justify-content: center;\n"])));
var Footer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n  font-size: ", ";\n  color: ", ";\n  letter-spacing: ", ";\n  padding: ", " 0;\n  border-top: ", " solid\n    ", ";\n"], ["\n  text-align: center;\n  font-size: ", ";\n  color: ", ";\n  letter-spacing: ", ";\n  padding: ", " 0;\n  border-top: ", " solid\n    ", ";\n"])), polished_1.rem(12), function (_a) {
    var theme = _a.theme;
    return theme.responsiveMenu.siteUrlColor;
}, polished_1.rem(1), polished_1.rem(30), polished_1.rem(3), function (_a) {
    var theme = _a.theme;
    return theme.responsiveMenu.siteUrlBorder;
});
var SiteUrl = function (props) {
    return (React.createElement(Wrapper, null,
        React.createElement(Footer, null, props.siteUrl)));
};
SiteUrl.propTypes = {
    siteUrl: PropTypes.string.isRequired,
};
exports.default = SiteUrl;
var templateObject_1, templateObject_2;
